import { render, staticRenderFns } from "./ScriptContent.vue?vue&type=template&id=2afd14b8&scoped=true"
import script from "./ScriptContent.vue?vue&type=script&lang=js"
export * from "./ScriptContent.vue?vue&type=script&lang=js"
import style0 from "./ScriptContent.vue?vue&type=style&index=0&id=2afd14b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd14b8",
  null
  
)

export default component.exports